import { CommonModule } from '@angular/common';
import { ComponentsModule } from '../../shared/components/components.module';
import { NewsIconComponent } from './components/news-icon/news-icon';
import { NewsService } from './services/news-service/news-service';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [CommonModule, ComponentsModule],
  providers: [NewsService],
  declarations: [NewsIconComponent],
  exports: [NewsIconComponent],
})
export class SellionsNewsModule {}



// WEBPACK FOOTER //
// ./src/modules/news/news.module.ts